import { KeyboardEvent } from 'react';

import useStyles from './LeadFormContainer.styles';

interface LeadFormContainerProps {
  children: React.ReactNode;
  className?: string;
  handleKeyDown?: (e: KeyboardEvent<HTMLFormElement>) => void;
}

// Must be used in conjunction with LeadFormTCPA component or a TCPA statement with appropriate hidden fields for leadId
export default function LeadFormContainer({
  children,
  className,
}: LeadFormContainerProps) {
  const { classes } = useStyles();

  return (
    <form className={className} aria-describedby='lead-form-description'>
      <span id='lead-form-description' className={classes.srOnly}>
        This form collects lead information for TCPA compliance.
      </span>
      {children}
    </form>
  );
}
